import { Spinner } from "components/spinner/Spinner";
import { ReactNode, useEffect, useState } from "react";
import { OwnerSummaryService } from "services/OwnerSummaryService";

interface IConfigProviderProps {
    children: ReactNode;
}

const ConfigProvider: React.FC<IConfigProviderProps> = ({ children }) => {

    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const initializeConfig = async () => {
          const ownerSummaryService = OwnerSummaryService.getInstance();
          // Add all the services that need to be initialized here
          await Promise.all([
            // TODO: The API is not available, I will use a mock data
            ownerSummaryService.loadConfig(),
          ]);
          setIsFetching(false);
        };
        initializeConfig();
      }, []);

    return (isFetching ? <Spinner data-testid="spinner" fullscreen /> : children)
}

export default ConfigProvider;
